import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { ProviderControllerApi } from "../../../services";
import { ProviderListItem } from "../../../types/provider-types";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

export interface UseProvidersReferralListProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey?: string;
  xTENANTID?: string;
  isReferral?: boolean; // This can be passed as a parameter if needed
  // enabled?: boolean; // Enable/disable the query
  // activeTab?: string; // Include activeTab to trigger refetch on tab change
  archive?: boolean;
  enabled?: boolean;
}

/**
 * @author Atish Bagate
 */
export function useProvidersReferralList({
  gridSorting,
  pagination,
  searchKey,
  xTENANTID,
  isReferral = false, // This can be passed as a parameter if needed
  archive = false,
  enabled = true,
}: // enabled = true, // Enable by default
// activeTab, // Include activeTab to trigger refetch on tab change
UseProvidersReferralListProps): useBaseContent<ProviderListItem> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "providers-referral-list",
      pageSize,
      pageIndex,
      searchKey,
      xTENANTID,
      isReferral,
      gridSorting,
      archive,
      // activeTab, // Include activeTab in query key to trigger refetch on tab change
      enabled,
    ],
    // enabled: enabled && !!xTENANTID, // Only run query when enabled and xTENANTID is available
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: enabled,
    queryFn: async () => {
      return new ProviderControllerApi(getConfigObject())
        .getProviderList(
          pageIndex, //page
          pageSize, //size
          sortData?.field, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          searchKey ?? undefined, //searchString
          archive, //archive
          xTENANTID //xTENANTID
        )
        .then((res) => asPaginatedContent<ProviderListItem>(res?.data));
    },
  });
}
